import { render, staticRenderFns } from "./creatAttr.vue?vue&type=template&id=819e0fca&scoped=true"
import script from "./creatAttr.vue?vue&type=script&lang=js"
export * from "./creatAttr.vue?vue&type=script&lang=js"
import style0 from "./creatAttr.vue?vue&type=style&index=0&id=819e0fca&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819e0fca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('819e0fca')) {
      api.createRecord('819e0fca', component.options)
    } else {
      api.reload('819e0fca', component.options)
    }
    module.hot.accept("./creatAttr.vue?vue&type=template&id=819e0fca&scoped=true", function () {
      api.rerender('819e0fca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/components/creatAttr.vue"
export default component.exports